import { Typography, Box, styled, Grid } from "@mui/material";
import React from "react";
import LaunchIcon from "@mui/icons-material/Launch";
import GitHubIcon from "@mui/icons-material/GitHub";

const Component = styled(Box)`
  width: 80%;
  background: #f6f6f6;
  text-align: center;
  align-items: center;
  margin: 0px auto;
  height: 600px;
  box-shadow: -12px -12px 25px white, 12px 12px 25px rgb(165 181 248 / 40%);
  border-radius: 10px;
  transition: 1s;
  &:hover {
    transform: scale(1.1);
  }
`;

const Image = styled("img")({
  width: "100%",
});

const Wrapper = styled(Box)`
  font-family: "Lora", serif;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  margin-top: 62px;
`;

const Tech = styled("span")({
  backgroundColor: "#eceffe",
  marginRight: "5px",
  borderRadius: "10px",
  color: "#1740ED",
  wordWrap: "break-word",
});

const Margin = styled(Grid)(({ theme }) => ({
  marginTop: "0px",
  [theme.breakpoints.down("lg")]: {
    marginTop: "50px",
  },
}));

const Boxes = ({
  image,
  title,
  description,
  technology,
  webSiteLink,
  github,
  image1,
  title1,
  description1,
  technology1,
  webSiteLink1,
  github1,
}) => {
  const WebsiteLink = () => {
    window.open(webSiteLink, "_blank");
  };

  const WebsiteLink1 = () => {
    window.open(webSiteLink1, "_blank");
  };

  const githubLink = () => {
    window.open(github, "_blank");
  };

  const githubLink1 = () => {
    window.open(github1, "_blank");
  };

  return (
    <Wrapper>
      <Grid container>
        <Grid item lg={6} md={12} sm={12}>
          <Component>
            <Box>
              <Image src={image} alt="portfolio_image" />
            </Box>
            <br />
            <Box>
              <Typography style={{ textAlign: "center", color: "#0b2590" }}>
                <h2>{title}</h2>
              </Typography>
              <Typography style={{ textAlign: "center", color: "#646464" }}>
                {description}
              </Typography>
              <br />
              <Tech>{technology[0]}</Tech>
              <Tech>{technology[1]}</Tech>
              <Tech>{technology[2]}</Tech>
              <Tech>{technology[3]}</Tech>
              <Tech>{technology[4]}</Tech>
              <ul
                style={{
                  listStyle: "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <li style={{ marginRight: "20px" }}>
                  <LaunchIcon onClick={WebsiteLink} />
                </li>
                <li>
                  <GitHubIcon onClick={githubLink} />
                </li>
              </ul>
            </Box>
          </Component>
        </Grid>
        <Margin item lg={6} md={12} sm={12}>
          <Component>
            <Box>
              <Image src={image1} alt="portfolio_image" />
            </Box>
            <br />
            <Box>
              <Typography style={{ textAlign: "center", color: "#0b2590" }}>
                <h2>{title1}</h2>
              </Typography>
              <Typography style={{ textAlign: "center", color: "#646464" }}>
                {description1}
              </Typography>
              <br />
              <Tech>{technology1[0]}</Tech>
              <Tech>{technology1[1]}</Tech>
              <Tech>{technology1[2]}</Tech>
              <Tech>{technology1[3]}</Tech>
              <Tech>{technology1[4]}</Tech>
              <ul
                style={{
                  listStyle: "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <li style={{ marginRight: "20px" }}>
                  <LaunchIcon onClick={WebsiteLink1} />
                </li>
                <li>
                  <GitHubIcon onClick={githubLink1} />
                </li>
              </ul>
            </Box>
          </Component>
        </Margin>
      </Grid>
    </Wrapper>
  );
};

export default Boxes;
